import { SELLER_PATH } from "../../origin";

export const imgs_list = [
  { url: 'top_swiper1' }, { url: 'top_swiper2' }, { url: 'top_swiper3' },
];

export const tabs_list = [{
  zh_title: '买家服务', en_title: 'Buyer Service',
  list: [
    { url: '', zh_title: '采购单', en_title: 'Purchase Order', link_url: '/basic/user/order', type: '' },
    { url: '', zh_title: '计划单', en_title: 'Planned Order', link_url: '/basic/user/planOrder', type: '' },
    { url: '', zh_title: '预售订单', en_title: 'Presale Order', link_url: '/basic/user/prePlanReport', type: '' },
    { url: '', zh_title: '进口商品提报', en_title: 'Import products Demand', link_url: '/basic/quotation', type: '' },
    { url: '', zh_title: '基地信息', en_title: 'Base Information', link_url: '/basic/location', type: '' },
    { url: '', zh_title: '联系我们', en_title: 'Contact Us', link_url: '', type: 'modal' },
  ]
}, {
  zh_title: '卖家服务', en_title: 'Seller Service',
  list: [
    { url: '', zh_title: '公司管理', en_title: 'Company Management', link_url: `${SELLER_PATH}/company/list`, type: '' },
    { url: '', zh_title: '商品管理', en_title: 'Product Management', link_url: `${SELLER_PATH}/product/productmanage`, type: '' },
    { url: '', zh_title: '订单管理', en_title: 'Order Management', link_url: `${SELLER_PATH}/purchaseorder/purchase`, type: '' },
    { url: '', zh_title: '预售管理', en_title: 'Presale Management', link_url: `${SELLER_PATH}/purchaseplan/presaleplan`, type: '' },
  ]
}];

export const classify_list = [
  {
    zh_title: '水果', en_title: 'Fruit', level: 1,
    list: [
      { zh_title: '热带水果类', en_title: 'Tropical Fruits', level: 2 },
      { zh_title: '核果类', en_title: 'Drupe', level: 2 },
      { zh_title: '柑桔类', en_title: 'Citrus', level: 2 },
      { zh_title: '仁果类', en_title: 'Pome', level: 2 },
      { zh_title: '瓜果类', en_title: 'Melon', level: 2 },
      { zh_title: '浆果类', en_title: 'Berries', level: 2 },
    ]
  },
  {
    zh_title: '蔬菜', en_title: 'Vegetables', level: 1,
    list: [
      { zh_title: '调味类', en_title: 'Seasoning', level: 2 },
      { zh_title: '根茎类', en_title: 'Rhizomes', level: 2 },
      { zh_title: '果菜类', en_title: 'Fruit Vegetable', level: 2 },
      { zh_title: '菌菇类', en_title: 'Mushrooms', level: 2 },
      { zh_title: '花菜类', en_title: 'Flower Vegetable', level: 2 },
    ]
  },
  {
    zh_title: '禽畜肉蛋', en_title: 'Meat and Eggs', level: 0,
    list: [
      { zh_title: '鸡肉', en_title: 'Chicken', level: 1 },
      { zh_title: '猪肉', en_title: 'Pork', level: 1 },
      { zh_title: '牛肉', en_title: 'Beef', level: 1,},
      { zh_title: '蛋类', en_title: 'Eggs', level: 1 },
      { zh_title: '羊肉', en_title: 'Mutton', level: 1 },
    ]
  },
  {
    zh_title: '水产', en_title: 'Seafood', level: 1,
    list: [
      { zh_title: '冷冻水产', en_title: 'Frozen Seafood', level: 2 },
      { zh_title: '冰鲜水产', en_title: 'Iced Seafood', level: 2 },
      { zh_title: '干水产类', en_title: 'Dried Seafood', level: 2 },
      { zh_title: '活鲜水产', en_title: 'Fresh Seafood', level: 2 },
    ]
  },
  {
    zh_title: '粮油米面', en_title: 'Grain,Oil,Rice And Flour', level: 0,
    list: [
      { zh_title: '大米/面粉', en_title: 'Rice/Flour', level: 1 },
      { zh_title: '食用油', en_title: 'Edible Oil', level: 1 },
      { zh_title: '调味品', en_title: 'Condiment', level: 1 },
      // { zh_title: '南北干货', en_title: 'Dry Goods' ,level:1},
      // { zh_title: '年节礼品类', en_title: 'Festival supplies' ,level:1},
    ]
  },
  {
    zh_title: '食品酒水', en_title: 'Food and Drinks', level: 0,
    list: [
      { zh_title: '酒水饮料', en_title: 'Drinks', level: 1 },
      { zh_title: '冷冻食品', en_title: 'Frozen Food', level: 1 },
      { zh_title: '休闲零食', en_title: 'Leisure Snacks', level: 1 },
      // { zh_title: '方便食品', en_title: 'Instant Food' ,level:1},
      // { zh_title: '乳制品', en_title: 'Dairy Products' ,level:1},
    ]
  },
  {
    zh_title: '宠物食品', en_title: 'Pet Food', level: 1,
    list: [
      { zh_title: '宠物狗食品', en_title: 'Dog Food', level: 2 },
      { zh_title: '宠物猫食品', en_title: 'Cat Food', level: 2 },
    ]
  },
];

export const link_config = [
  {
    zh_title: '邮箱', en_title: 'Email', detail: 'zhangshuqiang@cpgroup.cn',
  },
  {
    zh_title: '联系电话', en_title: 'Tel No', detail: '+8615522853360',
  },
];